import VerticalFlag from "../../../../../../packages/design-system/src/VerticalFlag";
import * as React from 'react';
export default {
  VerticalFlag,
  React
};